/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export const RelevantProject = styled.div({
  padding: `${token('space.100')} 0`,
  display: 'flex',
  justifyContent: 'space-between',
});

export const UnlinkAction = styled.div({
  display: 'flex',
  alignItems: 'center',
});

export const LinkedByText = styled.span({
  font: token('font.body.small'),
  color: token('color.text.subtlest', colors.N100),
  marginRight: token('space.100'),
  marginTop: token('space.negative.050'),
});

export const AlignCenter = styled.div({
  margin: `${token('space.200')} 0`,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
});

export const SubTitle = styled.span({
  font: token('font.body.UNSAFE_small'),
  fontWeight: token('font.weight.semibold'),
  color: token('color.text.subtlest'),
  marginTop: token('space.200'),
});

export const LinkedProjectsContainer = styled.div<{ hasProjects: boolean }>(
  props => ({
    marginTop: token('space.200'),
    marginBottom: props.hasProjects ? token('space.200') : 0,
  })
);
